import { atom } from 'jotai';

/**
 * One-shot composer prompt hand-off when navigating to a project from outside
 * its chat surface (e.g. sidebar "Create routine from chat"). ``ProjectChat``
 * consumes and clears it: ``submit`` sends the prompt as a follow-up beside any
 * draft, otherwise it lands in the input before paint.
 */
export const pendingComposerPromptAtom = atom<{
  projectId: string;
  prompt: string;
  submit?: boolean;
} | null>(null);
